/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import useSheet from '../../jss';
import * as spinnerSize from '../../constants/spinnerSizeTypes';

type Props = {
  center?: boolean,
  classes: Object,
  className?: string,
  inlineLeft?: boolean,
  inlineRight?: boolean,
  kind: 'light' | 'dark',
  size?: 'default' | 'small' | 'large',
  onRef?: (ref: any) => void
};

const defaultProps = {
  center: false,
  className: undefined,
  inlineLeft: false,
  inlineRight: false,
  size: 'default',
  onRef: undefined
};

function Spinner({
  center,
  className,
  inlineLeft,
  inlineRight,
  kind,
  classes,
  size,
  onRef
}: Props) {
  return (
    <span
      ref={onRef}
      className={classNames(
        className,
        classes.spinner,
        classes[kind],
        classes[size],
        {
          [classes.center]: center,
          [classes.inlineLeft]: inlineLeft,
          [classes.inlineRight]: inlineRight
        },
        className
      )}
    />
  );
}

Spinner.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    spinner: {
      animation: 'rotation .6s infinite linear',
      borderRadius: '100%',
      display: 'flex'
    },
    center: {
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    inlineLeft: {
      marginRight: theme.spacing.small
    },
    lineRight: {
      marginLeft: theme.spacing.small
    },
    default: {
      height: spinnerSize.DEFAULT,
      width: spinnerSize.DEFAULT
    },
    small: {
      height: spinnerSize.SMALL,
      width: spinnerSize.SMALL
    },
    large: {
      height: spinnerSize.LARGE,
      width: spinnerSize.LARGE
    },
    light: {
      borderBottom: '2px solid rgba(255, 255, 255, 0.3)',
      borderLeft: '2px solid rgba(255, 255, 255, 0.3)',
      borderRight: '2px solid rgba(255, 255, 255, 0.3)',
      borderTop: '2px solid rgba(255, 255, 255, 1)'
    },
    dark: {
      borderBottom: '2px solid rgba(0, 0, 0, 0.2)',
      borderLeft: '2px solid rgba(0, 0, 0, 0.2)',
      borderRight: '2px solid rgba(0, 0, 0, 0.2)',
      borderTop: '2px solid rgba(0, 0, 0, .6)'
    }
  };
}

function mapStateToProps(state, { kind }) {
  return {
    kind: kind || (!state.settings.darkMode ? 'dark' : 'light')
  };
}

// $FlowFixMe
export default connect(mapStateToProps)(useSheet(applyStyles)(Spinner));
